<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SystemMaintenance.TaxControlDiskNumberMaintenance')"
      width="1000px"
      :close-on-click-modal="false"
      @close="onCancel"
    >
      <cargo-ag-grid
        :grid-options="clientNoDialog.gridOptions"
        :column-defs="clientNoDialog.columnDefs"
        :row-data="rowData || []"
        style="width:100%;height:400px"
        @gridReady="params=>{gridApi=params.api}"
      />
      <div class="app-main-inner-row">
        <div class="filters" />
        <div class="triggers">
          <el-button size="mini" type="primary" @click="addItem">{{ $t('SystemMaintenance.Add') }}</el-button>
          <el-button
            size="mini"
            type="danger"
            :disabled="!clientNoDialog.selectedData"
            @click="removeItem"
          >{{ $t('SystemMaintenance.Delete') }}
          </el-button>
          <el-button size="mini" type="primary" @click="onSave">{{ $t('SystemMaintenance.Save') }}</el-button>
          <el-button size="mini" type="primary" @click="onCancel">{{ $t('SystemMaintenance.Cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAgGridAdvanceMultipleSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index'
import { saveTaxControlPanel } from '@/api/bankAccount'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import ColumnUtils from '@/utils/ColumnUtils'
import { getInvoiceTitlesByOffice } from '@/api/sysManage/officeInvoiceTitle'
export default {
  name: 'ClientNoWindow',
  components: { CargoAdvanceSelect, CargoAgGridAdvanceMultipleSelectEditor },
  props: {
    visible: { type: Boolean, required: true },
    rowData: { type: Array, required: true },
    deptList: { type: Array, required: false, default: null },
    oneOffice: { type: Object, required: true }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      loading: false,
      gridApi: null,
      deleteList: [],
      clientNoDialog: {
        isShow: false,
        isEditForm: false,
        gridOptions: {
          rowSelection: 'multiple',
          suppressRowClickSelection: true,
          singleClickEdit: true,
          onRowClicked: this.onRowClicked,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          frameworkComponents: {
            CargoAgGridAdvanceMultipleSelectEditor,
            CargoAgGridCommonInputEditor
          }
        },
        gridParams: {},
        columnDefs: [
          {
            headerName: this.$t('SystemMaintenance.Number'), colId: 'taxPanelNo', field: 'taxPanelNo', initialWidth: 200,
            valueFormatter: (params) => {
              return params.value
            },
            editable: true,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: false
            }
          }, {
            headerName: this.$t('SystemMaintenance.InvoiceCode'), colId: 'clientNo', field: 'clientNo', initialWidth: 200,
            valueFormatter: (params) => {
              return params.value
            },
            editable: true,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: false
            }
          },
          {
            headerName: this.$t('SystemMaintenance.UsageDepartment'), field: 'departmentIdList',
            colId: 'departmentNames', width: 350,
            editable: true,
            valueFormatter: (params) => {
              return this.departmentIdsLabFunc(params.data)
            },
            cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
            cellEditorParams: {
              selectProps: {
                multiple: true,
                tagValue: 'entityId',
                tagName: 'chineseName',
                staticOptions: [...this.deptList],
                filterable: true
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          }],
        sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
        selectedData: null
      },
      invoiceTitles: []
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  async beforeMount() {

  },
  methods: {
    addItem() {
      if (!this.rowData) {
        this.rowData = []
      }
      this.rowData.push({
        officeUuid: this.oneOffice.uuid,
        taxPanelNo: '',
        clientNo: '',
        departmentIds: '',
        departmentIdList: [],
        uuid: ''
      })
    },
    async onSave() {
      this.loading = getLoading4Cxt(this)
      const tip1 = await this.checkForm()
      if (!tip1) {
        this.loading.close()
      } else {
        const tip2 = await this.validateBankAccount()
        if (!tip2) {
          this.loading.close()
        } else {
          this.saveTaxControlPanelHandler()
        }
      }
    },
    async validateBankAccount() {
      if (this.rowData && this.rowData.length > 0) {
        for (const r of this.rowData) {
          if (this.checkRepeatByValue(r.taxPanelNo, 1)) {
            this.$message.warning(this.$t('SystemMaintenance.TheNumberCannotBeRepeated'))
            return false
          }
          if (this.checkRepeatByValue(r.clientNo, 2)) {
            this.$message.warning(this.$t('SystemMaintenance.InvoiceCodeCannotBeRepeated'))
            return false
          }
        }
        const departmentIds = this.getAllDepartmentIdList()
        const departmentId = this.checkRepeatByDepartmentId(departmentIds)
        if (departmentId) {
          const departmentName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(departmentId), 'chineseName')
          const flag = await this.$confirm(this.$t('CargoMsg.CheckTaxControlPanelNo', [departmentName]), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            dangerouslyUseHTMLString: true,
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => true).catch(() => false)
          if (!flag) {
            return false
          }
          // this.$message.warning('一个部门不允许维护多个税控盘编号')
          // return false
        }
      }
      return true
    },
    getAllDepartmentIdList() {
      const departmentIds = []
      for (const tax of this.rowData) {
        if (tax.departmentIds) {
          const departments = tax.departmentIds.split(',')
          for (const c of departments) {
            departmentIds.push(c)
          }
        }
      }
      return departmentIds
    },
    checkRepeatByDepartmentId(departmentIds) {
      const o = {}
      for (const d of departmentIds) {
        if (o[d] != null) {
          return o[d]
        } else {
          o[d] = d
        }
      }
      return ''
    },
    checkRepeatByValue(value, n) {
      let count = 0
      for (const tax of this.rowData) {
        if (value === tax.taxPanelNo && n === 1) {
          count += 1
        }
        if (value === tax.clientNo && n === 2) {
          count += 1
        }
      }
      return count > 1
    },
    saveTaxControlPanelHandler() {
      const saveList = []
      for (const data of this.rowData) {
        const saveData = {}
        saveData.uuid = data.uuid
        saveData.version = data.version
        saveData.officeUuid = data.officeUuid
        saveData.departmentIds = data.departmentIds
        saveData.clientNo = data.clientNo
        saveData.taxPanelNo = data.taxPanelNo
        saveList.push(saveData)
      }
      saveTaxControlPanel(saveList).then(res => {
        this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
      }).finally((e) => {
        this.loading.close()
      })
    },
    async checkForm() {
      if (this.rowData && this.rowData.length > 0) {
        for (const r of this.rowData) {
          if (!r.taxPanelNo) {
            this.$message.warning(this.$t('SystemMaintenance.NumberCannotBeEmpty'))
            return false
          }
          if (!r.clientNo) {
            this.$message.warning(this.$t('SystemMaintenance.InvoiceCodeCannotBeEmpty'))
            return false
          }
          if (!r.departmentIds) {
            this.$message.warning(this.$t('SystemMaintenance.UsageDepartmentCannotBeEmpty'))
            return false
          }
          r.taxPanelNo = String(r.taxPanelNo).trim()
          r.clientNo = String(r.clientNo).trim()
          r.departmentIds = String(r.departmentIds).trim()
        }
      }
      return true
    },
    onRowClicked(event) {
      if (!event || !event.data) return
      this.clientNoDialog.selectedData = event.data
    },
    async removeItem() {
      if (this.clientNoDialog.selectedData) {
        if (!await this.checkInvoiceTitlesByOffice(this.clientNoDialog.selectedData.uuid)) {
          return
        }
        const index = this.rowData.findIndex(p => p.uuid === this.clientNoDialog.selectedData.uuid)
        if (index > -1) {
          this.deleteList.push(this.clientNoDialog.selectedData.uuid)
          this.rowData.splice(index, 1)
          this.clientNoDialog.selectedData = null
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
      }
    },
    onCellChange(e) {
      const data = e.data
      if (data.departmentIdList) {
        let text = ''
        for (const data of data.departmentIdList) {
          if (text.length !== 0) {
            text = text + ','
          }
          text = text + data
        }
        data.departmentIds = text
      } else {
        data.departmentIds = ''
      }
    },
    departmentIdsLabFunc(data) {
      let text = ''
      if (data.departmentIds) {
        const array = data.departmentIds.split(',')
        for (const item of array) {
          for (const d of this.deptList) {
            if (item === String(d.entityId)) {
              if (text) {
                text += ','
              }
              text += d.chineseName
            }
          }
        }
      }
      return text
    },
    onCancel() {
      this.invoiceTitles = []
      this.$emit('updateClientNos')
      this.$emit('update:visible', false)
    },
    // 校验税控信息关联开票抬头信息
    async checkInvoiceTitlesByOffice(clientNoUuid = '') {
      if (!clientNoUuid) return true // 为空不校验
      if (!this.invoiceTitles || this.invoiceTitles.length <= 0) {
        await getInvoiceTitlesByOffice({ officeId: this.oneOffice.officeId }).then(res => {
          this.invoiceTitles = res.data
        })
      }
      for (const item of this.invoiceTitles) {
        if (item.taxControlPanelUuid && item.taxControlPanelUuid.indexOf(clientNoUuid) !== -1) {
          this.$message.warning(this.$t('CargoMsg.TaxControlPanelNoHasInvoiceTitle'))
          return false
        }
      }
      return true
    }
  }
}
</script>
